module.exports = __webpack_public_path__ + "static/media/pan2Explore.b57b6e58.png";